import React, { useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import CompaniesIcon from "../../Assets/CustomIcons/CompaniesIcon";
import AssignmentIcon from "@material-ui/icons/Assignment";
import { useHistory } from "react-router-dom";
import {
  Box,
  Collapse,
  IconButton,
  makeStyles,
  useTheme,
  withStyles,
} from "@material-ui/core";
import {
  MenuDashboardIcon,
  LinkToJobIcon,
  MenuJobsIcon,
  MenuLibiExploreIcon,
  MenuSettingsIcon,
  MenuCandidatesIcon,
} from "../../Assets/CustomIcons/CustomIconsList";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import { Primary } from "../../config/colors";

const StyleListItem = withStyles(() => ({
  root: {
    "&.Mui-selected": {
      backgroundColor: Primary.light,
      "& .MuiListItemIcon-root": {
        color: Primary.dark,
      },
      "& .MuiTypography-root": {
        color: Primary.dark,
      },
      "& .MuiSvgIcon-root": {
        color: Primary.dark,
      },
    },
    "&:hover": {
      backgroundColor: Primary.main,
      "& .MuiListItemIcon-root": {
        color: Primary.dark,
      },
      "& .MuiTypography-root": {
        color: Primary.contrastText,
      },
      "& .MuiListItemIcon-root": {
        color: Primary.contrastText,
      },
      "& .MuiSvgIcon-root": {
        color: "#fff",
      },
    },

    "& .MuiListItemIcon-root": {
      minWidth: 40,
    },
  },
}))(ListItem);

const useStyles = makeStyles((theme) => ({
  root: {},
  collapsableSelected: {
    borderLeft: `4px solid ${theme.palette.primary.main}`,
  },
}));

const MainMenuItems = (props) => {
  const history = useHistory();
  const theme = useTheme();
  const classes = useStyles();
  const [subItemSelected, setSubItemSelected] = useState([]);

  const handleGoToJobs = () => {
    sessionStorage.removeItem("ljp");
    history.push("/jobs");
  };

  const mainListItems = (
    <div>
      <StyleListItem
        button
        selected={history.location.pathname === "/dashboard"}
        onClick={() => history.push("/dashboard")}
      >
        <ListItemIcon>
          <MenuDashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </StyleListItem>
      <StyleListItem
        button
        selected={history.location.pathname === "/companies"}
        onClick={() => history.push("/companies")}
        className={
          history.location.pathname.includes("/companies")
            ? classes.collapsableSelected
            : ""
        }
      >
        <ListItemIcon>
          <CompaniesIcon viewBox="0 0 36 36" />
        </ListItemIcon>
        <ListItemText primary="Companies" />
        <IconButton
          onClick={() => setSubItemSelected((prev) => [...prev, "companies"])}
        >
          <KeyboardArrowDownRoundedIcon />
        </IconButton>
      </StyleListItem>
      <Collapse
        in={
          subItemSelected.includes("companies") ||
          history.location.pathname === "/companies/signal-manager"
        }
      >
        <Box
          style={{ backgroundColor: theme.palette.primary.light }}
          className={
            history.location.pathname.includes("/companies")
              ? classes.collapsableSelected
              : ""
          }
        >
          <StyleListItem
            button
            onClick={() => history.push("/companies/signal-manager")}
            selected={true}
          >
            <ListItemIcon></ListItemIcon>
            <ListItemText primary="Signal Manager" />
          </StyleListItem>
        </Box>
      </Collapse>

      <StyleListItem
        button
        selected={history.location.pathname === "/candidates"}
        onClick={() => history.push("/candidates")}
      >
        <ListItemIcon>
          <MenuCandidatesIcon />
        </ListItemIcon>
        <ListItemText primary="Candidates" />
      </StyleListItem>
      <StyleListItem
        button
        selected={history.location.pathname === "/jobs"}
        onClick={handleGoToJobs}
      >
        <ListItemIcon>
          <MenuJobsIcon />
        </ListItemIcon>
        <ListItemText primary="Jobs" />
      </StyleListItem>
      <StyleListItem
        button
        selected={history.location.pathname === "/explore"}
        onClick={() => history.push("/explore")}
      >
        <ListItemIcon>
          <MenuLibiExploreIcon />
        </ListItemIcon>
        <ListItemText primary="Explore" />
      </StyleListItem>
      <StyleListItem
        button
        selected={history.location.pathname === "/settings"}
        onClick={() => history.push("/settings")}
      >
        <ListItemIcon>
          <MenuSettingsIcon />
        </ListItemIcon>
        <ListItemText primary="System Settings" />
      </StyleListItem>
    </div>
  );
  const secondaryListItems = (
    <div>
      <ListSubheader inset style={{ paddingLeft: theme.spacing(7) }}>
        Additional Information
      </ListSubheader>
      <StyleListItem
        button
        selected={props.screen === "activityReport"}
        onClick={() => history.push("/activityReport")}
      >
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Activity Report" />
      </StyleListItem>

      <StyleListItem
        button
        selected={props.screen === "horecaReport"}
        onClick={() => history.push("/horecaReport")}
      >
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Horeca Activity Report" />
      </StyleListItem>
      <StyleListItem
        button
        selected={props.screen === "tracers"}
        onClick={() => history.push("/tracers")}
        disabled
      >
        <ListItemIcon>
          <LinkToJobIcon />
        </ListItemIcon>
        <ListItemText primary="Tracers" />
      </StyleListItem>
    </div>
  );

  return props.list === "main" ? mainListItems : secondaryListItems;
};

export default MainMenuItems;
